import { STORAGE_KEY } from '../../shared/config';
import { getJSONItem, setItem } from '../../shared/services/storage/storage';
import { getNextWorkingDays } from '../../shared/services/workingDays/getWorkingDays';
import { holidaysList } from '../constants/holidaysList';
import type { State, Action, Fields, Field, FieldProps } from '../types';
import { FieldTypes } from '../types/fieldTypes';
import { isCheckboxField } from '../types/guards';

export function reducer(state: State, action: Action): State {
  if (action.type === 'set_errors') {
    return {
      ...state,
      [action.value.fieldName]: { ...state[action.value.fieldName], errors: action.value.errors },
    };
  }

  if (action.type === 'set_step_has_errors') {
    return {
      ...state,
      hasErrors: action.value,
    };
  }

  if (action.type === 'set_Data') {
    const nextAvailableDaysList = getNextWorkingDays(3, holidaysList);
    const [day, month, year] = nextAvailableDaysList[0].split('/');
    const initialNextAvailableDay = `${year}-${('0' + month).slice(-2)}-${('0' + day).slice(-2)}`;
    return {
      ...state,
      nextAvailableDaysList,
      Data: {
        ...state.Data,
        code: state.Data.code,
        value: initialNextAvailableDay,
        errors: [],
      },
      hasErrors: undefined,
    };
  }

  if (action.type.startsWith('set_')) {
    const fieldName = action.type.replace('set_', '');
    return {
      ...state,
      [fieldName]: {
        ...state[fieldName],
        code: state[fieldName].code,
        value: action.value.fieldValue,
        ...(action.value.fieldName && { decodeValue: action.value.fieldName }),
        errors: [],
      },
      hasErrors: undefined,
    };
  }

  if (action.type.startsWith('add_')) {
    const fieldName = action.type.replace('add_', '');
    const field = state[fieldName];
    const fieldValue = field.value;
    const fieldCode = field.code;
    return {
      ...state,
      [fieldName]: {
        ...state[fieldName],
        code: fieldCode,
        value: fieldValue.find(({ fieldValue }: FieldProps) => fieldValue === action.value.fieldValue)
          ? fieldValue.filter(({ fieldValue }: FieldProps) => fieldValue !== action.value.fieldValue)
          : [...fieldValue, { fieldValue: action.value.fieldValue, fieldName: action.value.fieldName }],
        errors: [],
      },
      hasErrors: undefined,
    };
  }

  console.error('Unknown action.');
  return state;
}

export const initState = (fields: Fields[]) => (initialState: State) => {
  const savedState = getJSONItem(STORAGE_KEY.B2C_STATE, null);
  if (savedState !== null) {
    return savedState;
  }

  fields.forEach((step, i) => {
    step.forEach((field) => {
      initialState[field.name] = {
        ...field,
        value: initialValue(field),
        step: i,
        validations: field?.errors,
      };
    });
  });
  setItem(STORAGE_KEY.B2C_STATE, initialState);
  return initialState;
};

function initialValue(field: Field) {
  if (isCheckboxField(field)) {
    return [];
  }
  if (field.type === FieldTypes.number) {
    return 0;
  }
  return '';
}
